type DAIRY_TYPE = {
  title: string
  id: string
}
export const dairyTypes: DAIRY_TYPE[] = [
  { title: '心好累', id: 'b4eae6984ccb4138bc999a77b2a33e06' },
  { title: '碎碎念', id: '7841d70ac88b4baaaaf9b9b21bf2f1b8' },
  { title: '学会提问', id: '88820b53a4884720ae3b65cdd2678aad' },
  { title: '我真棒', id: '803d5a31730a4ef09823f5c10136bf0f' },
  { title: '生活锦囊', id: '4184727c924b41339e2d0c74f3856b84' },
  { title: '好事发生', id: 'b3f83d8bfc4349bc895be6293aa09ced' },
  { title: '下次一定', id: '2cd516ed87a04f6593a20c27b137f4ae' },
]
